import { memo as o } from "react";
import { c as r } from "../../createReactComponent-ec43b511.js";
import "../../_commonjsHelpers-10dfc225.js";
var t = r("arrow-down", "IconArrowDown", [
  ["path", { d: "M12 5l0 14", key: "svg-0" }],
  ["path", { d: "M18 13l-6 6", key: "svg-1" }],
  ["path", { d: "M6 13l6 6", key: "svg-2" }]
]);
const m = o(t);
export {
  m as default
};
